import { isDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';

import {
  useCheckTargetAccumulatorByTradeCapture,
  useTargetAccumulatorSelector,
  useTargetAccumulatorTileId,
} from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { TargetAccumulatorFormField } from '@/App/tiles/TargetAccumulator/TargetAccumulatorFormField.tsx';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput/index.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectTargetAccumulatorValidation } from '@/store/targetAccumulator/selectors.ts';

const EkiUp = () => {
  const tileId = useTargetAccumulatorTileId();
  const ekiUp = useTargetAccumulatorSelector((targetAccumulator) => targetAccumulator?.properties.ekiUp);
  const isCustom = useTargetAccumulatorSelector(
    (targetAccumulator) => targetAccumulator?.properties.customFields?.includes('EkiUp') ?? false,
  );
  const { sgwtWebAnalytics } = useSgwtWidgets();

  const validation = useAppSelector((state) => selectTargetAccumulatorValidation(state, tileId));

  const checkTargetAccumulatorWithTradeCapture = useCheckTargetAccumulatorByTradeCapture();

  const handleEkiUp = (value: number | undefined) => {
    sgwtWebAnalytics?.trackEvent('Target Accumulator', 'EkiUp changed', isDefined(value) ? String(value) : 'null');
    return checkTargetAccumulatorWithTradeCapture({
      ekiUp: isDefined(value) ? value : null,
    });
  };

  return (
    <TargetAccumulatorFormField formattedMessageId="targetAccumulator.form.ekiUp">
      <TradeCaptureValidationWrapper validation={validation?.ekiUp}>
        <SgNumberInput
          valuePosition="start"
          className={isCustom ? 'text-info' : undefined}
          data-e2e-is-modified={isCustom}
          selectAllOnFocus
          value={ekiUp}
          maxDecimals={9}
          onChange={handleEkiUp}
          size="sm"
          data-e2e="eki-up"
          allowNegative={false}
        />
      </TradeCaptureValidationWrapper>
    </TargetAccumulatorFormField>
  );
};

export default EkiUp;
